import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "besidaMob-preview.icon",
  "use": "besidaMob-preview.icon-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"besidaMob-preview.icon\"><path d=\"M41.625 60.375L16 32 41.625 3.625 48.5 10 28.375 32 48.5 54z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol